import { makeResponses } from '../response_factory';
import { utils as coreUtils, requestParams } from '@codegrade/api-core';
import { UserLoginResponse } from '@codegrade/api-models';
import { parsers } from '@codegrade/utils';
const makeResult = coreUtils.makeResult;
// eslint-disable-next-line @typescript-eslint/no-unused-vars,unused-imports/no-unused-vars
const parseJsonResponse = /* #__PURE__ */ parsers.parseJsonResponse;
export function saml(config) {
    const getSessionResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(/* #__PURE__ */ parseJsonResponse(UserLoginResponse)),
    });
    return Object.freeze({
        /**
         * Get a JWT token for a user after doing a successful launch.
         *
         * This method will use various pieces of information from the session from the requested user.
         *
         * This method can only be used once to retrieve the JWT, as the data will be removed after the first request.
         *
         * @param arg The arguments to the function.
         * @param arg.token The token that we will use to verify that you are the correct owner of the SAML launch. This data will be cross referenced to stored data and your session.
         * @returns A mapping containing one key (`access_token`).
         */
        getSession: async ({ token, }) => {
            const result = await requestParams(config, 'POST', `/api/sso/saml2/jwts/${token}`, getSessionResponse.v, undefined);
            return result;
        },
    });
}
